import React from 'react'

const SvgComponent = ({size,color}) => (
  <svg viewBox="0 0 299.997 299.997"  width={size} height={size}>
    <path d="M149.996 0C67.157 0 .001 67.158.001 149.997c0 82.837 67.156 150 149.995 150s150-67.163 150-150C299.996 67.156 232.835 0 149.996 0zm.457 220.763v-.002H85.465c0-46.856 41.152-46.845 50.284-59.097l1.045-5.587c-12.83-6.502-21.887-22.178-21.887-40.512 0-24.154 15.712-43.738 35.089-43.738s35.089 19.584 35.089 43.738c0 18.178-8.896 33.756-21.555 40.361l1.19 6.349c10.019 11.658 49.802 12.418 49.802 58.488h-64.069z"
      fill={color}
      />
  </svg>
)

export default SvgComponent

/*
import React from 'react'

const SvgComponent = ({size,color}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 611 611"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"

  >
    <path
      d="M611 306C611 138 474 0 305 0 137 0-1 137-1 306c0 89 38 169 99 225l10 8 2 2c5 4 11 8 16 12 2 1 4 3 5 4l18 12c1 1 3 2 4 2 7 4 14 8 21 11 1 0 1 0 2 1 23 11 48 19 74 23h2c8 1 16 3 24 3h3c8 1 16 1 25 1 8 0 17 0 25-1h3l24-3h2c25-5 50-12 73-23 1 0 2-1 3-1 7-3 14-7 20-10 2-1 3-2 5-3 6-4 12-7 18-11 2-1 4-3 6-4 5-3 10-7 14-11 1-1 2-2 3-2l10-9c61-56 100-136 100-226zm-589 0C22 150 149 23 305 23s283 127 283 283c0 84-37 160-95 212-3-2-7-4-10-6l-94-47c-8-4-14-13-14-22v-33c2-3 5-6 7-9 12-17 22-36 29-57 14-7 23-21 23-37v-39c0-10-4-19-10-26v-52c1-6 3-38-21-65-20-23-54-35-99-35s-78 12-99 35c-24 27-21 59-21 65v52c-6 7-10 17-10 26v39c0 12 5 24 15 31 9 35 28 62 34 71v32c0 9-5 17-13 22l-88 48c-3 2-6 3-8 5-58-52-94-127-94-211zm450 229c-4 3-8 6-12 8-2 1-4 2-6 4-5 3-11 6-16 9-1 1-2 1-4 2-13 6-26 12-39 16h-1l-21 6c-7 2-14 3-22 4h-1l-21 3h-4c-7 0-14 1-21 1s-14 0-21-1h-4c-7-1-14-1-21-3h-1c-15-3-29-6-43-11h-1c-7-2-14-5-21-8-6-3-13-6-19-9-1 0-2-1-2-1-6-3-11-6-17-10-2-1-3-2-5-3-5-3-10-7-15-10l-1-1 1-1 88-48c15-8 24-24 24-41v-40l-3-3s-24-29-33-69l-1-4-4-2c-5-3-9-9-9-15v-39c0-5 2-10 6-14l4-3v-63s-3-27 16-48c16-18 44-28 82-28s66 9 82 27c19 21 16 48 16 49v63l4 3c4 4 6 8 6 14v39c0 8-5 15-13 18l-6 2-2 6c-7 20-16 39-28 56-3 4-6 8-8 11l-3 3v41c0 18 10 34 26 42l94 47c1 0 1 1 2 1-1 1-2 2-4 3z"
      fillRule="nonzero"
      fill={color}
    />
  </svg>
)

export default SvgComponent
*/
